<template>
  <div id="quote-component">
    <p class="quote">“{{ randomQuote.quote }}” -{{ randomQuote.attributedTo }}</p>
  </div>
</template>

<script>
export default {
  name: 'QuoteComponent',
  data: () => {
    return {
      quotes: [
        { quote: 'Sometimes even to live is an act of courage.', attributedTo: 'Seneca' },
        { quote: 'Luck is what happens when preparation meets opportunity.', attributedTo: 'Seneca' },
        { quote: 'Difficulties strengthen the mind, as labor does the body.', attributedTo: 'Seneca' },
        {
          quote: 'Hang on to your youthful enthusiasms -- you’ll be able to use them better when you’re older.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'You act like mortals in all that you fear, and like immortals in all that you desire.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'We suffer more often in imagination than in reality.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'Begin at once to live, and count each separate day as a separate life.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'Only time can heal what reason cannot.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'As long as you live, keep learning how to live.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'Every new beginning comes from some other beginnings end.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'It is difficult to bring people to goodness with lessons, but it is easy to do so by example.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'It\'s not because things are difficult that we dare not venture. It\'s because we dare not venture that they are difficult.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'The mind that is anxious about future events is miserable.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'The best ideas are common property.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'It is of course better to know useless things than to know nothing.',
          attributedTo: 'Seneca'
        },
        {
          quote: 'Don\'t explain your philosophy. Embody it.',
          attributedTo: 'Epictetus'
        },
        {
          quote: 'Nothing great is created suddenly, any more than a bunch of grapes or a fig.',
          attributedTo: 'Epictetus'
        },
        {
          quote: 'When you arise in the morning, think of what a precious privilege it is to be alive - to breathe, to think, to enjoy, to love.',
          attributedTo: 'Marcus Aurelius'
        },
        {
          quote: 'Nothing is more hostile to a firm grasp on knowledge than self-deception.Nothing is more hostile to a firm grasp on knowledge than self-deception.',
          attributedTo: 'Zeno of Citium'
        },
        {
          quote: 'Nothing is more hostile to a firm grasp on knowledge than self-deception.Nothing is more hostile to a firm grasp on knowledge than self-deception.',
          attributedTo: 'Zeno of Citium'
        }
      ],
      randomQuote: []
    }
  },
  created: function () {
    this.randomQuote = this.getQuote()
  },
  methods: {
    getQuote () {
      // Grab random quote from array
      return this.quotes[Math.floor(Math.random() * this.quotes.length)]
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/QuoteComponent.vue